import { render, staticRenderFns } from "./_betListHDPOUDetails.vue?vue&type=template&id=53507450&lang=pug&"
import script from "./_betListHDPOUDetails.vue?vue&type=script&lang=js&"
export * from "./_betListHDPOUDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports